export default __webpack_public_path__ + "static/media/ncstate.3645d1d5.png";